module.exports = __webpack_public_path__ + "static/img/19.9bf7eec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carrusel/19.png
// module id = 692k
// module chunks = 5